import { KeyboardEvent, MouseEvent, useState } from "react";
import { InfoCircleOutlined } from "@ant-design/icons";
import { Popover } from "antd";
import { TextService } from "../../Services/TextService";

/**
 * An info symbol that shows an explanation. Used next to a label or a checkbox instead of a line of help
 * text below it. A light box rather than a dark tooltip, since the texts are often a few sentences. It opens
 * on hover, on click/tap (so it works on a phone) and with Enter or Space when the symbol has focus.
 */
export const InfoTooltip = (props: { text?: string }) => {
    const [open, setOpen] = useState(false);

    if (!props.text) {
        return null;
    }

    // Help texts written to stand below a field are wrapped in parentheses, which the box doesn't need.
    const text = props.text.trim().replace(/^\((.*)\)$/s, "$1");

    // The symbol often sits inside a label, where a click would also tick the checkbox or focus the field.
    const onClick = (e: MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
    }

    const onKeyDown = (e: KeyboardEvent) => {
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            e.stopPropagation();
            setOpen(!open);
        }
        if (e.key === "Escape") {
            setOpen(false);
        }
    }

    // Light blue like the chosen card in EventTypeSelect, with a border and a clear shadow so it stands out
    // from the white form. It opens to the right of the symbol so it isn't squeezed against the page edge.
    return <Popover content={<div style={{ maxWidth: "320px" }}>{text}</div>} trigger={["hover", "click"]} open={open} onOpenChange={setOpen}
        placement="topLeft" arrow={{ pointAtCenter: true }} color="#eef5ff"
        styles={{ body: { border: "1px solid #d9d9d9", boxShadow: "0 6px 20px rgba(0, 0, 0, 0.18)" } }}>
        <span role="button" tabIndex={0} aria-label={TextService.GetText("InfoTooltip_AriaLabel")} aria-expanded={open}
            onClick={onClick} onKeyDown={onKeyDown} style={{ marginLeft: "6px", cursor: "help" }}>
            <InfoCircleOutlined style={{ color: "#1677ff" }} />
        </span>
    </Popover>;
};
